import React, { useState, useEffect } from "react";

// Helper function to calculate and format duration
const calculateDuration = (startTime) => {
  if (!startTime) return "Invalid start time";

  let startDate;

  try {
    if (typeof startTime === "string") {
      startDate = new Date(startTime);
    } else if (typeof startTime === "number") {
      startDate =
        startTime > 1000000000000
          ? new Date(startTime)
          : new Date(startTime * 1000);
    } else {
      throw new Error("Invalid startTime format");
    }

    if (isNaN(startDate.getTime())) {
      throw new Error("Invalid Date");
    }
  } catch (error) {
    console.error("Error parsing startTime:", error.message);
    return "Invalid start time";
  }

  const now = new Date();
  const diff = now.getTime() - startDate.getTime();

  if (diff < 0) return "0s"; // Avoid negative durations

  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  const parts = [];
  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0) parts.push(`${minutes}m`);
  if (seconds > 0 || parts.length === 0) parts.push(`${seconds}s`);

  return parts.join(" ");
};

// Reusable DurationCounter component
const DurationCounter = ({ startTime, className = "" }) => {
  const [duration, setDuration] = useState("0s");

  useEffect(() => {
    if (!startTime) {
      console.warn("Invalid or missing startTime prop");
      return;
    }

    setDuration(calculateDuration(startTime));

    const intervalId = setInterval(() => {
      setDuration(calculateDuration(startTime));
    }, 1000);

    return () => clearInterval(intervalId);
  }, [startTime]);

  return <span className={className}>{duration}</span>;
};

export default DurationCounter;
